import CryptoJS from 'crypto-js';

// 密钥，需要与后端保持一致
const secret = 'c81b7d38b57d7dbabcd3c38dc37446f4'; // 请替换为实际密钥

export function decrypt(word) {
  let key = CryptoJS.enc.Utf8.parse(secret);
  let decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}